import { observer } from 'mobx-react';
import React, { ChangeEvent, FC, useEffect } from 'react';
import './attendees-search.scss';
import { ReactComponent as SearchIcon } from '../../../../../assets/icons/search.svg';
import { ReactComponent as CloseIcon } from '../../../../../assets/icons/close-icon.svg';
import { useStore } from '../../../../../store/store-provider';
import useDebounce from '../../../../../utils/hooks/useDebounce';

const AttendeesSearch: FC = () => {
  const { attendeesStore: { getAttendeesService, searchCallbackBuilder }} = useStore();
  const { onSearch, searchQueryString, inputSearchValue, isSearch } = getAttendeesService();

  const boldInputCls: string = inputSearchValue ? 'filled-inp': '';
  const debouncedValue: string = useDebounce<string>(searchQueryString);

  const onSearchHandler = (event: ChangeEvent<HTMLInputElement>): void => {
    const { target: { value }} = event;
    onSearch(value);
  };

  const onClearSearchField = (): void => {
    onSearch('');
  };

  useEffect(() => {
    if(!isSearch) return;
    searchCallbackBuilder();
  }, [debouncedValue]);

  return (
    <div className={`attendees-search ${boldInputCls}`}>
      <input
        type='text'
        placeholder='Search'
        onChange={onSearchHandler}
        value={inputSearchValue}
      />
      {inputSearchValue
        ? <CloseIcon className='clear-search' onClick={onClearSearchField}/>
        : <SearchIcon className='search-icon'/>
      }
    </div>
  );
};

export default observer(AttendeesSearch);